// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: kvajJ2MSr9DNMA2u1PusCw
// Component: xu3fpqICCpUV
import * as React from "react";
import {
  Stack as Stack__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import DisabilityItem from "../../DisabilityItem"; // plasmic-import: lpfdmLwrBWTS/component
import BtnText from "../../BtnText"; // plasmic-import: R3LXVa6EIz/component
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import projectcss from "../blank_project/plasmic_blank_project.module.css"; // plasmic-import: kvajJ2MSr9DNMA2u1PusCw/projectcss
import sty from "./PlasmicDiabilityModal.module.css"; // plasmic-import: xu3fpqICCpUV/css
import Icon12Icon from "./icons/PlasmicIcon__Icon12"; // plasmic-import: LYoK9OD3Rv/icon

createPlasmicElementProxy;

export const PlasmicDiabilityModal__VariantProps = new Array();

export const PlasmicDiabilityModal__ArgProps = new Array();

const $$ = {};

function PlasmicDiabilityModal__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        sty.root
      )}
    >
      <div className={classNames(projectcss.all, sty.freeBox__cz6B1)}>
        <div className={classNames(projectcss.all, sty.freeBox__fHeTb)}>
          <div className={classNames(projectcss.all, sty.freeBox___5IIPo)}>
            <div className={classNames(projectcss.all, sty.freeBox__idowW)}>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text___6KqT2
                )}
              >
                {"Disability"}
              </div>
              <Icon12Icon
                data-plasmic-name={"btnClose"}
                data-plasmic-override={overrides.btnClose}
                className={classNames(projectcss.all, sty.btnClose)}
                role={"img"}
              />
            </div>
            <Stack__
              as={"div"}
              hasGap={true}
              className={classNames(projectcss.all, sty.freeBox__nItkN)}
            >
              <div className={classNames(projectcss.all, sty.freeBox__yvfM)}>
                <DisabilityItem
                  data-plasmic-name={"hearing"}
                  data-plasmic-override={overrides.hearing}
                  className={classNames("__wab_instance", sty.hearing)}
                />

                <DisabilityItem
                  data-plasmic-name={"sight"}
                  data-plasmic-override={overrides.sight}
                  className={classNames("__wab_instance", sty.sight)}
                >
                  <div
                    data-plasmic-name={"sight2"}
                    data-plasmic-override={overrides.sight2}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.sight2
                    )}
                  >
                    {"Sight (even with glasses)"}
                  </div>
                </DisabilityItem>
                <DisabilityItem
                  data-plasmic-name={"communication"}
                  data-plasmic-override={overrides.communication}
                  className={classNames("__wab_instance", sty.communication)}
                >
                  <div
                    data-plasmic-name={"comms"}
                    data-plasmic-override={overrides.comms}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.comms
                    )}
                  >
                    {"Communication (talking, listening)"}
                  </div>
                </DisabilityItem>
                <DisabilityItem
                  data-plasmic-name={"physical"}
                  data-plasmic-override={overrides.physical}
                  className={classNames("__wab_instance", sty.physical)}
                >
                  <div
                    data-plasmic-name={"physical2"}
                    data-plasmic-override={overrides.physical2}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.physical2
                    )}
                  >
                    {"Physical (moving, standing, grasping)"}
                  </div>
                </DisabilityItem>
                <DisabilityItem
                  data-plasmic-name={"disabled"}
                  data-plasmic-override={overrides.disabled}
                  className={classNames("__wab_instance", sty.disabled)}
                >
                  <div
                    data-plasmic-name={"unspecified2"}
                    data-plasmic-override={overrides.unspecified2}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.unspecified2
                    )}
                  >
                    {"Disabled but unspecified"}
                  </div>
                </DisabilityItem>
                <DisabilityItem
                  data-plasmic-name={"intellectual"}
                  data-plasmic-override={overrides.intellectual}
                  className={classNames("__wab_instance", sty.intellectual)}
                >
                  <div
                    data-plasmic-name={"learning"}
                    data-plasmic-override={overrides.learning}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.learning
                    )}
                  >
                    {"Intellectual (difficulties in learning)"}
                  </div>
                </DisabilityItem>
                <DisabilityItem
                  data-plasmic-name={"emotional"}
                  data-plasmic-override={overrides.emotional}
                  className={classNames("__wab_instance", sty.emotional)}
                >
                  {"Emotional (behavioural or psychological)"}
                </DisabilityItem>
              </div>
              <div
                data-plasmic-name={"btnFilter"}
                data-plasmic-override={overrides.btnFilter}
                className={classNames(projectcss.all, sty.btnFilter)}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__qFvH2
                  )}
                >
                  {"Save"}
                </div>
              </div>
              <div
                data-plasmic-name={"assessorComment"}
                data-plasmic-override={overrides.assessorComment}
                className={classNames(projectcss.all, sty.assessorComment)}
              />

              <Stack__
                as={"div"}
                hasGap={true}
                className={classNames(projectcss.all, sty.freeBox__mtSao)}
              >
                {false ? (
                  <BtnText
                    data-plasmic-name={"btnSubmit"}
                    data-plasmic-override={overrides.btnSubmit}
                    className={classNames("__wab_instance", sty.btnSubmit)}
                    green={true}
                  >
                    {"Submit"}
                  </BtnText>
                ) : null}
                <BtnText
                  data-plasmic-name={"btnCloseBottom"}
                  data-plasmic-override={overrides.btnCloseBottom}
                  className={classNames("__wab_instance", sty.btnCloseBottom)}
                  orange={true}
                >
                  {"Submit"}
                </BtnText>
              </Stack__>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__cvtJt
                )}
              >
                {
                  "The assessment has been submitted, and is ready for release to the moderator. To release the assessment or make changes to your marking, visit the To Be Released section or Return to To Be Marked"
                }
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__lwkov)}>
                {false ? (
                  <BtnText
                    data-plasmic-name={"btnMark"}
                    data-plasmic-override={overrides.btnMark}
                    className={classNames("__wab_instance", sty.btnMark)}
                    green={true}
                  >
                    {"Submit"}
                  </BtnText>
                ) : null}
                <BtnText
                  data-plasmic-name={"btnRelease"}
                  data-plasmic-override={overrides.btnRelease}
                  className={classNames("__wab_instance", sty.btnRelease)}
                  green={true}
                >
                  {"Submit"}
                </BtnText>
              </div>
              <div
                data-plasmic-name={"loadingSvg2"}
                data-plasmic-override={overrides.loadingSvg2}
                className={classNames(projectcss.all, sty.loadingSvg2)}
              />
            </Stack__>
            <div className={classNames(projectcss.all, sty.freeBox__xyhPm)}>
              <div className={classNames(projectcss.all, sty.freeBox__j82Xh)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text___5XxDj
                  )}
                >
                  {"Flags"}
                </div>
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__bYptk)}>
                <div className={classNames(projectcss.all, sty.freeBox___8OG6)}>
                  <div
                    className={classNames(projectcss.all, sty.freeBox__sja9B)}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__kOznO
                      )}
                    >
                      {"A -"}
                    </div>
                    <div
                      data-plasmic-name={"txtA"}
                      data-plasmic-override={overrides.txtA}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.txtA
                      )}
                    >
                      {" 1"}
                    </div>
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.freeBox__ePif0)}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text___9Oj7C
                      )}
                    >
                      {"S -"}
                    </div>
                    <div
                      data-plasmic-name={"txtS"}
                      data-plasmic-override={overrides.txtS}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.txtS
                      )}
                    >
                      {" 1"}
                    </div>
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.freeBox__ju2Ju)}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__dSqQj
                      )}
                    >
                      {"R -"}
                    </div>
                    <div
                      data-plasmic-name={"txtR"}
                      data-plasmic-override={overrides.txtR}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.txtR
                      )}
                    >
                      {" 1"}
                    </div>
                  </div>
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__grrnH)}>
                  <div
                    className={classNames(projectcss.all, sty.freeBox__zeGfZ)}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__yDoHn
                      )}
                    >
                      {"B -"}
                    </div>
                    <div
                      data-plasmic-name={"txtB"}
                      data-plasmic-override={overrides.txtB}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.txtB
                      )}
                    >
                      {" 1"}
                    </div>
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.freeBox__ekHe5)}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text___8Bakd
                      )}
                    >
                      {"C -"}
                    </div>
                    <div
                      data-plasmic-name={"txtC"}
                      data-plasmic-override={overrides.txtC}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.txtC
                      )}
                    >
                      {" 1"}
                    </div>
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.freeBox__s3Zci)}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__lWkUq
                      )}
                    >
                      {"P -"}
                    </div>
                    <div
                      data-plasmic-name={"txtP"}
                      data-plasmic-override={overrides.txtP}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.txtP
                      )}
                    >
                      {" 1"}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "btnClose",
    "hearing",
    "sight",
    "sight2",
    "communication",
    "comms",
    "physical",
    "physical2",
    "disabled",
    "unspecified2",
    "intellectual",
    "learning",
    "emotional",
    "btnFilter",
    "assessorComment",
    "btnSubmit",
    "btnCloseBottom",
    "btnMark",
    "btnRelease",
    "loadingSvg2",
    "txtA",
    "txtS",
    "txtR",
    "txtB",
    "txtC",
    "txtP"
  ],

  btnClose: ["btnClose"],
  hearing: ["hearing"],
  sight: ["sight", "sight2"],
  sight2: ["sight2"],
  communication: ["communication", "comms"],
  comms: ["comms"],
  physical: ["physical", "physical2"],
  physical2: ["physical2"],
  disabled: ["disabled", "unspecified2"],
  unspecified2: ["unspecified2"],
  intellectual: ["intellectual", "learning"],
  learning: ["learning"],
  emotional: ["emotional"],
  btnFilter: ["btnFilter"],
  assessorComment: ["assessorComment"],
  btnSubmit: ["btnSubmit"],
  btnCloseBottom: ["btnCloseBottom"],
  btnMark: ["btnMark"],
  btnRelease: ["btnRelease"],
  loadingSvg2: ["loadingSvg2"],
  txtA: ["txtA"],
  txtS: ["txtS"],
  txtR: ["txtR"],
  txtB: ["txtB"],
  txtC: ["txtC"],
  txtP: ["txtP"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicDiabilityModal__ArgProps,
          internalVariantPropNames: PlasmicDiabilityModal__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicDiabilityModal__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicDiabilityModal";
  } else {
    func.displayName = `PlasmicDiabilityModal.${nodeName}`;
  }
  return func;
}

export const PlasmicDiabilityModal = Object.assign(
  // Top-level PlasmicDiabilityModal renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    btnClose: makeNodeComponent("btnClose"),
    hearing: makeNodeComponent("hearing"),
    sight: makeNodeComponent("sight"),
    sight2: makeNodeComponent("sight2"),
    communication: makeNodeComponent("communication"),
    comms: makeNodeComponent("comms"),
    physical: makeNodeComponent("physical"),
    physical2: makeNodeComponent("physical2"),
    disabled: makeNodeComponent("disabled"),
    unspecified2: makeNodeComponent("unspecified2"),
    intellectual: makeNodeComponent("intellectual"),
    learning: makeNodeComponent("learning"),
    emotional: makeNodeComponent("emotional"),
    btnFilter: makeNodeComponent("btnFilter"),
    assessorComment: makeNodeComponent("assessorComment"),
    btnSubmit: makeNodeComponent("btnSubmit"),
    btnCloseBottom: makeNodeComponent("btnCloseBottom"),
    btnMark: makeNodeComponent("btnMark"),
    btnRelease: makeNodeComponent("btnRelease"),
    loadingSvg2: makeNodeComponent("loadingSvg2"),
    txtA: makeNodeComponent("txtA"),
    txtS: makeNodeComponent("txtS"),
    txtR: makeNodeComponent("txtR"),
    txtB: makeNodeComponent("txtB"),
    txtC: makeNodeComponent("txtC"),
    txtP: makeNodeComponent("txtP"),
    // Metadata about props expected for PlasmicDiabilityModal
    internalVariantProps: PlasmicDiabilityModal__VariantProps,
    internalArgProps: PlasmicDiabilityModal__ArgProps
  }
);

export default PlasmicDiabilityModal;
/* prettier-ignore-end */
